// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { EditPartner, Partner, PartnerGroup } from '../interfaces/partners.interface';
import { DataProcessingService } from './data-prcessing.service';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class PartnersService { 
   private get apiUrl(): string {
     return this.loggerService.resolveApiUrl('partner');
   }

   constructor(
     private http: HttpClient,
     private dataProcess: DataProcessingService,
     private loggerService: LoggerService
   ) {}

  getData(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<Partner>> {
    params = params || {}; // Default to active partners
    return this.http.get<GenericResponseWithTotal<Partner>>(this.apiUrl, { params: this.dataProcess.fitlerParams(params) });
  }

  getPartners(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<Partner>> {
    return this.http.get<GenericResponseWithTotal<Partner>>(`${this.apiUrl}/admin/list`, { params: this.dataProcess.fitlerParams(params) });
  }

  getPartner(id: number): Observable<Partner> {
    return this.http.get<Partner>(`${this.apiUrl}/${id}`);
  }

  setActive(id: number, active_value: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/set_active/${id}/${active_value}`);
  }

  updatePartner(id: number, data: EditPartner): Observable<Partner> {
    return this.http.put<Partner>(`${this.apiUrl}/${id}`, data);
  }

  updateCurrentPartner(partnerId: number,data: EditPartner): Observable<Partner> {
    return this.http.put<Partner>(`${this.apiUrl}/current/${partnerId}`, data);
  }


  createPartner(data: Partial<EditPartner>): Observable<Partner> {
    return this.http.post<Partner>(this.apiUrl, data);
  }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.apiUrl}/upload`, formData);
  }

  deletePartner(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }


  getPartnerGroup(): Observable<Array<PartnerGroup>> {
    return this.http.get<Array<PartnerGroup>>(`${this.apiUrl}/group`);
  }

  changeSort(id: number, direction: 'UP' | 'DOWN'): Observable<any> {
    const url = `${this.apiUrl}/sort`;
    return this.http.get<any>(url, {
      params: {
        id: id.toString(),
        direction
      }
    });
  }

}